import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowPathRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowPathRight"><Path d="M2.5 15.5V8.5H13.5V4.75L22.25 12L13.5 19.25V15.5H2.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowPathRight;
